import React from "react";
import "./Orleans.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Orleans6images from "../../Media/Orleans/Orleans 6/Orleans6";
import Orleans7images from "../../Media/Orleans/Orleans 7/Orleans7";
import Orleans8images from "../../Media/Orleans/Orleans 8/Orleans8";

const imageMap = {
  Orleans6images,
  Orleans7images,
  Orleans8images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="orlens" className="produk-orleans">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
